import { motion } from "framer-motion";
import { 
  BarChart3, 
  TrendingUp, 
  Shield, 
  Zap, 
  Download, 
  Bell,
  LineChart,
  PieChart
} from "lucide-react";

const features = [
  {
    icon: BarChart3,
    title: "Sharpe Ratio",
    description: "Measure your risk-adjusted returns. Know if your profits come from skill or variance."
  },
  {
    icon: TrendingUp,
    title: "Max Drawdown",
    description: "Track your worst peak-to-trough decline. Understand your true risk exposure."
  },
  {
    icon: LineChart,
    title: "Equity Curve",
    description: "Visualize your account value over time. Spot trends and turning points."
  },
  {
    icon: PieChart,
    title: "Volume Analysis",
    description: "Daily volume breakdowns, fee analysis, and trading frequency insights."
  },
  {
    icon: Shield,
    title: "Read-Only Access",
    description: "We never request trading permissions. Your funds stay completely safe."
  },
  {
    icon: Zap,
    title: "Real-Time Sync",
    description: "Fresh data on demand. Pro users get unlimited refreshes."
  },
  {
    icon: Download,
    title: "CSV Export",
    description: "Export your complete trading history for taxes, backtesting, or analysis."
  },
  {
    icon: Bell,
    title: "Weekly Reports",
    description: "Get performance summaries delivered to your inbox every week."
  }
];

const container = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};

const item = {
  hidden: { opacity: 0, y: 20 },
  show: { opacity: 1, y: 0 }
};

export const Features = () => {
  return (
    <section className="py-24 md:py-32 relative">
      <div className="container px-4">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Everything you need to <span className="text-primary">know your edge</span>
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            Professional-grade analytics that were once reserved for institutional traders.
            Now accessible to everyone on Hyperliquid.
          </p>
        </motion.div>

        {/* Features grid */}
        <motion.div
          variants={container}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6"
        >
          {features.map((feature, index) => (
            <motion.div
              key={feature.title}
              variants={item}
              className="stat-card group cursor-default"
            >
              <div className="flex items-center justify-center w-12 h-12 rounded-lg bg-primary/10 mb-4 group-hover:bg-primary/20 transition-colors">
                <feature.icon className="w-6 h-6 text-primary" />
              </div>
              <h3 className="text-lg font-semibold mb-2">{feature.title}</h3>
              <p className="text-sm text-muted-foreground">{feature.description}</p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};
